import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {CustomAxiosError, useApiCalls} from "../../../../../../logics/api_config";
import {useAuth} from "../../../../../../utils/contexts/auth-context";
import {
    IMyCompanyWarehouse
} from "../../../../../../utils/interfaces/my_company/my_company_warehouse/IMyCompanyWarehouse";


const useApiGetMyCompanyWarehouses = (): UseQueryResult<IMyCompanyWarehouse[], CustomAxiosError> => {
    const {selectedCompany} = useAuth();

    const {get} = useApiCalls()

    async function doGet(company_token: string | undefined): Promise<IMyCompanyWarehouse[]> {
        try {
            const response = await get(`/api/company/${company_token}/my_company/my_company_warehouse`);
            return response?.data;
        } catch (error) {
            throw error;
        }
    }

    return useQuery({
        queryKey: ["useApiGetMyCompanyWarehouses"],
        queryFn: () => doGet(selectedCompany?.company_token,),
    })
};

export default useApiGetMyCompanyWarehouses